import React from "react";
import PortalLayout from "../components/PortalLayout";

export default function DeleteAccount() {
    return (
        <PortalLayout>
            <section
                className="max-w-2xl mx-auto px-6 md:px-12 pt-20 pb-32"
                data-testid="delete-account-page"
            >
                <span className="font-label text-[11px] text-[#cfa052]">Legal · privacy</span>
                <h1
                    className="mt-4 font-serif-display text-5xl md:text-6xl tracking-tighter text-[#e8e4db]"
                    data-testid="delete-account-title"
                >
                    Account &amp; Data Deletion
                </h1>
                <p className="mt-3 font-poetic text-sm text-[#6e6a62]">Last updated: June 2026</p>

                <div className="mt-12 space-y-10 font-poetic text-[#9a958a] text-lg leading-relaxed">
                    <p>
                        We respect your right to delete your account and personal data at any time. There are two ways to do this.
                    </p>

                    <div>
                        <h2 className="font-serif-display text-2xl text-[#e8e4db] mb-3">
                            Option 1 — Delete from inside the app <span className="text-[#cfa052] text-base align-middle">(instant, recommended)</span>
                        </h2>
                        <ol className="space-y-2 list-decimal list-inside marker:text-[#cfa052]">
                            <li>Open the Angel Squad Inspirations app.</li>
                            <li>Sign in to your account.</li>
                            <li>Tap the <span className="text-[#e8e4db]">Profile</span> tab (bottom right).</li>
                            <li>Scroll to the bottom and tap <span className="text-[#e8e4db]">Delete Account</span>.</li>
                            <li>Confirm the deletion.</li>
                        </ol>
                        <p className="mt-4">
                            Your account and all associated data will be permanently deleted from our servers within 24 hours.
                        </p>
                    </div>

                    <div>
                        <h2 className="font-serif-display text-2xl text-[#e8e4db] mb-3">
                            Option 2 — Email request <span className="text-[#cfa052] text-base align-middle">(if you no longer have the app installed)</span>
                        </h2>
                        <p>
                            If you can&rsquo;t access the app, email{" "}
                            <a
                                href="mailto:hello@myangelsquad.com?subject=Delete%20my%20account"
                                className="text-[#cfa052] hover:text-[#e0b569] underline underline-offset-4"
                                data-testid="delete-account-email-link"
                            >
                                hello@myangelsquad.com
                            </a>{" "}
                            from the email address registered to your account with the subject line{" "}
                            <span className="text-[#e8e4db]">&ldquo;Delete my account&rdquo;</span>.
                        </p>
                        <p className="mt-4">We will:</p>
                        <ul className="mt-2 space-y-2 list-disc list-inside marker:text-[#cfa052]">
                            <li>Verify the request is from the account owner.</li>
                            <li>Permanently delete your account and all associated data within 7 days.</li>
                            <li>Confirm completion via reply email.</li>
                        </ul>
                    </div>

                    <div>
                        <h2 className="font-serif-display text-2xl text-[#e8e4db] mb-3">What data is deleted</h2>
                        <p>When you delete your account, we permanently remove:</p>
                        <ul className="mt-3 space-y-2 list-disc list-inside marker:text-[#cfa052]">
                            <li>Your email address and display name.</li>
                            <li>Your password hash and login credentials.</li>
                            <li>All inspirations, prayer requests, revelations, and comments you posted.</li>
                            <li>Your notification preferences and push notification tokens.</li>
                            <li>
                                Your subscription history (Stripe transaction records are retained for up to 7 years as
                                required by tax/financial regulations &mdash; these contain timestamps only, no card data).
                            </li>
                            <li>Analytics events linked to your user ID.</li>
                        </ul>
                    </div>

                    <div>
                        <h2 className="font-serif-display text-2xl text-[#e8e4db] mb-3">What may be retained</h2>
                        <ul className="space-y-3 list-none">
                            <li>
                                <span className="text-[#e8e4db]">Anonymous content:</span> comments and prayers you wrote on shared public posts may remain visible but will no longer be linked to your name or account.
                            </li>
                            <li>
                                <span className="text-[#e8e4db]">Financial records:</span> Stripe payment timestamps (no card details) are retained for tax/financial compliance per legal requirements.
                            </li>
                            <li>
                                <span className="text-[#e8e4db]">Backup snapshots:</span> encrypted database backups containing your data are automatically purged within 30 days.
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h2 className="font-serif-display text-2xl text-[#e8e4db] mb-3">Questions?</h2>
                        <p>
                            Contact{" "}
                            <a
                                href="mailto:hello@myangelsquad.com"
                                className="text-[#cfa052] hover:text-[#e0b569] underline underline-offset-4"
                            >
                                hello@myangelsquad.com
                            </a>{" "}
                            for any questions about your data or this process.
                        </p>
                    </div>
                </div>
            </section>
        </PortalLayout>
    );
}
